import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-organigram-bio]')) return;

  dataLayerOrganigramBio();
}

function dataLayerOrganigramBio() {
  $$('[data-au-organigram-bio-link]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('section').querySelector('[data-au-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });
}

export default { init };
